module.exports = __webpack_public_path__ + "fonts/euclid-square-300.24882cc9.ttf";